<template>

  <div class="mt-4">
    <div class="row mb-2">
      <div class="col-md-9">
        <b-card class="mb-4 shadow-sm">
          <div class="d-flex mb-0 align-items-center justify-content-end">
            <help-icon class="mr-2" size="18"/>
            <span>{{ $t('info.tva.honoraire') }}</span>
          </div>
          <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
            <div class="mb-4">
              <div class="section-title">
                {{ $t('simulationHonoraire.general') }}
              </div>
              <template v-for="simulationHonoraire in simulationHonoraires">
                <div
                  v-if="((simulationHonoraire.data.simulation != null && simulationHonoraire.data.simulation.id === simulationId) || (simulationHonoraire.selectedLots.length !== 0))">
                  <simulation-honoraire-component
                    :simulation-honoraire="simulationHonoraire.data"
                    :is-operation-linked="isOperationLinked"
                    :operation-id="operationId"
                    @didChangeValue="emitChangeValue()"
                    @removedSimulationHonoraire="removedSimulationHonoraire"/>

                  <div class="custom-container">
                    <template v-for="(simulationLot, index) in simulationLots">
                      <b-form-checkbox
                        :key="index*simulationLot.lotNumber  + '-checkbox-key'"
                        :checked="simulationHonoraire.selectedLots && simulationHonoraire.selectedLots.includes(simulationLot.id)"
                        @change="toggleLotSelection(simulationHonoraire, simulationLot.id)"
                      >
                        {{ $t('SimulationLot') + ' ' + simulationLot.lotNumber }}
                      </b-form-checkbox>
                    </template>
                  </div>
                </div>
              </template>
              <div class="row mt-2 mb-4">
                <div class="col-md-12">
                  <span class="bold-text addLink"
                        @click="addSimulationHonoraireGeneral(simulation)"> {{
                      $t('simulationHonoraire.Add')
                    }}</span>
                </div>
              </div>
            </div>
            <div v-for="simulationLot in simulationLots" class="mb-4">

              <div class="row">
                <div class="col-md-12">
                  <span class="section-title">{{ simulationLot.tostring }}</span>
                </div>
              </div>

              <template v-for="simulationHonoraire in simulationHonoraires">
                <simulation-honoraire-component
                  v-if="simulationHonoraire.data.simulationLot != null && (simulationHonoraire.data.simulationLot.id === simulationLot.id && simulationHonoraire.selectedLots.length === 0)"
                  :simulation-honoraire="simulationHonoraire.data"
                  :is-operation-linked="isOperationLinked"
                  :operation-id="operationId"
                  @didChangeValue="emitChangeValue"
                  @removedSimulationHonoraire="removedSimulationHonoraire"/>
              </template>

              <div class="row mt-2 mb-4">
                <div class="col-md-12">
                  <span class="bold-text addLink"
                        @click="addSimulationHonoraire(simulationLot)"> {{ $t('simulationHonoraire.Add') }}</span>
                </div>
              </div>

            </div>

            <div class="d-flex justify-content-end">
              <b-button class="mr-3" variant="outline-primary" @click="back">{{ $t('Back') }}</b-button>
              <b-button type="submit" variant="primary">{{ $t('Save.and.Continue') }}</b-button>
            </div>
          </b-form>
        </b-card>
      </div>

      <div class="col-md-3">
        <SimulationBilanCardPrice
          :prices="totalPrices">
        </SimulationBilanCardPrice>
      </div>
    </div>
    <div>
    </div>
    <add-simulation-honoraire-modal
      :simulation="selected.simulation"
      :simulationLot="selected.simulationLot"
      :types="types"
      @didAddSimulationHonoraire="didAddSimulationHonoraire"/>

  </div>

</template>

<script>

import api from '../../../services/api'
import AddSimulationHonoraireModal from "../components/AddSimulationHonoraireModal";
import SimulationHonoraireComponent from "../components/SimulationHonoraireComponent";
import SimulationBilanCardPrice from "./components/SimulationBilanCardPrice.vue";

export default {

  name: "SimulationHonoraires",

  components: {
    SimulationBilanCardPrice,
    SimulationHonoraireComponent,
    AddSimulationHonoraireModal,
  },

  props: {
    simulationId: {
      type: Number,
      default: null
    },
    isOperationLinked: {
      type: Boolean,
      default: false
    },
    operationId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      simulationLots: [],
      simulation: null,
      simulationHonoraires: [],
      types: [],
      selected: {
        simulation: null,
        simulationLot: []
      },
      totalPrices: []
    }
  },

  emits: ['didContinueHonoraires', 'didBack', 'didChangeValue'],

  mounted() {
    this.fetchData()
    console.log('operationId dans SimulationHonoraires:', this.operationId)
  },

  methods: {

    async fetchData() {
      await this.getSimulationLots()
      await this.getSimulation()
      await this.getSimulationHonoraires()
      await this.fetchContactTypes()
      await this.getTotalOfBilan()
    },

    async getSimulationLots() {
      if (this.simulationId != null) {
        await api
          .get(`/simulationLot/getAllForSimulation/${this.simulationId}`)
          .then(response => {
            this.simulationLots = response.data
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async getSimulation() {
      if (this.simulationId != null) {
        await api
          .get(`/simulation/${this.simulationId}`)
          .then(response => {
            this.simulation = response.data
          })
      }
    },

    async getTotalOfBilan() {
      await api
        .get(`/simulation/getTotalOfBilan/${this.simulationId}`)
        .then(response => {
          this.totalPrices = response.data
        })
    },

    async getSimulationHonoraires() {
      if (this.simulationId != null) {
        await api
          .get(`/simulationHonoraire/getAllForSimulation/${this.simulationId}`)
          .then(response => {
            const tempHonoraires = {}

            response.data.forEach(honoraire => {
              if (honoraire.commonId && honoraire.commonId !== '') {
                if (!tempHonoraires[honoraire.commonId]) {
                  tempHonoraires[honoraire.commonId] = {
                    data: honoraire,
                    selectedLots: []
                  }
                }
                tempHonoraires[honoraire.commonId].selectedLots.push(honoraire.simulationLot.id)
              } else {
                tempHonoraires[honoraire.id] = {
                  data: honoraire,
                  selectedLots: honoraire.simulation.id ? this.simulationLots.map(lot => lot.id) : []
                }
              }
            })

            this.simulationHonoraires = Object.values(tempHonoraires)
            this.simulationHonoraires.forEach(honoraire => {
              if (honoraire['data']['commonId'] != null) {
                honoraire['data']['prixTTC'] = honoraire['data']['prixTTC'] * honoraire['selectedLots'].length
              }
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationShow',
                params: {
                  simulationId: this.simulationId,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async fetchContactTypes() {
      await api
        .get(`/contact/getContactTypes`)
        .then(response => {
          response.data.forEach(type => {
            if (!this.types.includes(this.$i18n.t(type))) {
              this.types.push(this.$i18n.t(type))
            }
          })
        })
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    addSimulationHonoraire(simulationLot) {
      this.selected.simulationLot = simulationLot
      this.$bvModal.show('add-simulation-honoraire-modal')
    },

    addSimulationHonoraireGeneral(simulation) {
      this.selected.simulation = simulation
      this.$bvModal.show('add-simulation-honoraire-modal')
    },

    didAddSimulationHonoraire(simulationHonoraire) {
      let simulationLotsIds = []
      if (this.selected.simulation != null) {
        this.simulationLots.forEach(lot => {
          simulationLotsIds.push(lot.id)
        })
      }
      this.selected.simulation = null
      this.selected.simulationLot = null
      this.simulationHonoraires.push({data: {...simulationHonoraire}, selectedLots: simulationLotsIds})
    },

    toggleLotSelection(simulationHonoraire, lotId) {
      const index = simulationHonoraire.selectedLots.indexOf(lotId)
      if (index === -1) {
        simulationHonoraire.selectedLots.push(lotId)
      } else {
        simulationHonoraire.selectedLots.splice(index, 1)
      }
    },

    removedSimulationHonoraire(simulationHonoraire) {
      let index = this.simulationHonoraires.findIndex((obj) => JSON.stringify(obj.data) === JSON.stringify(simulationHonoraire))

      if (index > -1) {
        this.simulationHonoraires.splice(index, 1)
      }
    },

    back() {
      this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
        this.$emit('didBack')
      })
    },

    async onSubmit() {
      await this.createOrUpdateSimulationHonoraires()
      await this.editSimulation()
      this.$emit('didContinueHonoraires')
    },

    async createOrUpdateSimulationHonoraires() {
      for (const simulationHonoraire of this.simulationHonoraires) {
        // Vérifier si l'honoraire est lié à des postes d'opération
        let hasLinkedOperations = false
        if (this.operationId && simulationHonoraire.data.id) {
          try {
            const response = await api.get(`/simulationHonoraire/getLinkedOperations?simulationHonoraireId=${simulationHonoraire.data.id}`)
            hasLinkedOperations = response.data.honorairesAVP.length > 0 || response.data.honorairesEXE.length > 0
          } catch (error) {
            console.error('Erreur lors de la vérification des postes liés:', error)
          }
        }

        // Si l'honoraire est lié à des postes, on ne met à jour que le prix
        if (hasLinkedOperations) {
          let data = new FormData()
          data.append('prixTTC', simulationHonoraire.data.prixTTC)

          await api({
            method: 'POST',
            url: `/simulationHonoraire/${simulationHonoraire.data.id}/updatePrice`,
            data: data
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
        } else {
          // Pour les honoraires non liés, on fait une mise à jour complète
        let data = new FormData()
        if (simulationHonoraire.data.simulationLot != null) {
          data.append('simulationLotId', simulationHonoraire.data.simulationLot.id)
        }
        if (simulationHonoraire.data.simulation != null) {
          data.append('simulationId', simulationHonoraire.data.simulation.id)
          data.append('selectedLotsIds', simulationHonoraire.selectedLots)
        }
        data.append('type', simulationHonoraire.data.type)
        data.append('prixTTC', simulationHonoraire.data.prixTTC)

        let url = 'simulationHonoraire'
        if (simulationHonoraire.data.id) {
          url = '/simulationHonoraire/' + simulationHonoraire.data.id
        }

        await api({
          method: 'POST',
          url: url,
          data: data
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
      }
      }
    },

    async editSimulation() {
      let data = new FormData()
      data.append('honorairesCreationDone', true)

      api({
        method: 'POST',
        url: '/simulation/' + this.simulationId,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    }

  }

}

</script>

<style scoped>

.custom-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: -1em;
  flex-wrap: wrap;
}

.custom-container > * {
  white-space: nowrap;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/simulation/createEditSteps/SimulationHonoraires.vue